import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { GoodreadsLogo } from "@/components/site/brands";

export default function TrustBar({ config }) {
  const badges = config?.trust_badges || [];
  const goodreads = config?.goodreads_author_url || "#";
  return (
    <section className="bg-[#F9FAFB] border-y border-gray-100 py-12 sm:py-14">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="flex flex-col lg:flex-row items-center lg:items-center justify-between gap-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-10 gap-y-4 flex-1">
            {badges.map((b, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.07 }}
                className="flex items-center gap-3"
                data-testid={`trust-badge-${i}`}
              >
                <span className="flex-shrink-0 h-6 w-6 rounded-full bg-gold/15 grid place-items-center">
                  <Check size={14} className="text-gold" strokeWidth={3} />
                </span>
                <span className="text-sm font-medium text-gray-800">{b}</span>
              </motion.div>
            ))}
          </div>
          <a
            href={goodreads}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="trust-goodreads-cta"
            className="btn-ink btn-pill shrink-0"
          >
            Read Reviews on
            <span className="bg-white rounded-md px-2 py-1"><GoodreadsLogo className="h-4 w-auto" /></span>
          </a>
        </div>
      </div>
    </section>
  );
}
